module.exports = {
  getWrapBehavior: require('./get-wrap-behavior'),
  wrapBehavior: require('./wrap-behavior')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/event/index.js
// module id = 286
// module chunks = 0 1 2